<template>
    <vx-dropdown-item
        :href="computedHref"
        :disabled="disabled"
        @click="handleClick">
        <slot></slot>
    </vx-dropdown-item>
</template>

<script setup lang="ts">
import { VxDropdownItem } from '@voxie/frontend-components';
import { computed } from 'vue';
import { useRouter, type RouteLocationRaw } from 'vue-router';
import { useRouterNavigation } from '~/composables/useRouterNavigation';

const props = withDefaults(defineProps<{
    to: RouteLocationRaw;
    href?: string;
    disabled?: boolean;
}>(), {
    disabled: false,
});

const router = useRouter();
const { navigate } = useRouterNavigation();

const computedHref = computed((): string | undefined => {
    if (props.href) {
        return props.href;
    }

    if (props.to) {
        const resolved = router.resolve(props.to);
        return resolved.href;
    }

    return undefined;
});

const handleClick = (event: MouseEvent | KeyboardEvent): void => {
    if (props.to && !props.disabled) {
        navigate(props.to, event);
    }
};
</script>
